import styled from 'styled-components';
import colors from '@/theme/constants/colors';
import StyledIcon from '@/atoms/Icon/styles';
import pxToRem from '@/theme/helpers/pxToRem';
import zIndex from '@/theme/constants/zIndex';

export const StyledOptions = styled.div`
  background: ${colors.white};
  border-radius: 40px;
  border: 1px solid ${colors.darkBlue25};
  position: absolute;
  display: flex;
  width: fit-content;
  top: -58px;
  z-index: ${zIndex.popover};
`;

export const StyledContainer = styled.div`
  position: relative;
  width: fit-content;
  display: inline-flex;
  justify-content: center;
`;

export const StyledLinkOption = styled.a`
  display: inline-flex;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  margin: ${pxToRem(5)};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid ${colors.grey25};
  background: ${colors.grey25};
  cursor: pointer;

  ${StyledIcon} {
    color: ${colors.darkBlue100};
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: ${colors.white};
      border: 1px solid ${colors.red100};

      ${StyledIcon} {
        color: ${colors.red100};
      }
    }
  }

  &:active {
    background: ${colors.red100};

    ${StyledIcon} {
      color: ${colors.white};
    }
  }
`;

export const StyledButtonOption = styled(StyledLinkOption).attrs({as: 'button'})`
  &:focus {
    outline: none;
  }
`;
